var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.895682 0.510917L0 1.40029L1.43183 2.83212C0.769529 3.82872 0.384765 5.02086 0.384765 6.30762C0.384765 9.78942 3.21058 12.6152 6.69238 12.6152C7.97914 12.6152 9.17128 12.2305 10.1679 11.5682L11.5997 13L12.4891 12.1106L0.895682 0.510917ZM6.69238 11.3537C3.91072 11.3537 1.64629 9.08928 1.64629 6.30762C1.64629 5.37409 1.9049 4.50364 2.35274 3.74672L9.25327 10.6473C8.49636 11.0951 7.62591 11.3537 6.69238 11.3537ZM4.13149 1.96798L3.21688 1.04706C4.21349 0.384765 5.40563 0 6.69238 0C10.1742 0 13 2.82581 13 6.30762C13 7.59437 12.6152 8.78651 11.9529 9.78311L11.032 8.8622C11.4799 8.1116 11.7385 7.24114 11.7385 6.30762C11.7385 3.52596 9.47404 1.26152 6.69238 1.26152C5.75885 1.26152 4.8884 1.52014 4.13149 1.96798Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.5db0834403a9a936ffdc39d7150dea7d.svg";
export { ForwardRef as ReactComponent };